import instance from "./axios";
import { MaterialFoilType } from "../types/materialFoilTypes";
import { FoilCutterPostPayload, FoilType } from "../types/foilCutterTypes";

export const fetchAllFoilTypes = async (
  stationId?: number
): Promise<FoilType[]> => {
  const response = await instance.get("/v1.0/Material/GetAllFoilTypes");
  const data: FoilType[] = response.data;
  if (stationId == null) return data;
  return data
    .filter((f) => f.standardFoil === 1 || f.standardFoil === stationId)
    .map(({ id, name, standardFoil }) => ({ id, name, standardFoil }));
};

export const fetchLastMaterialFoil = async (
  stationId: number
): Promise<MaterialFoilType[]> => {
  const response = await instance.get<MaterialFoilType[]>(
    `/v1.0/Material/GetLastMaterialFoil/${stationId}/15`
  );
  return Array.isArray(response.data) ? response.data : [response.data];
};

export const postMaterialFoil = async (data: FoilCutterPostPayload) => {
  const response = await instance.post("/v1.0/Material/AddMaterialFoil", data);
  return response.data;
};
